import { useLang } from "../context/LanguageContext";
import { sectionT } from "../i18n/translations";
import { translateDish } from "../i18n/dishNames";

export default function MenuSection({ section, index = 0 }) {
  const { lang, tx, t } = useLang();
  const heading = sectionT[section.sectionKey]?.[lang] || section.sectionKey;
  const reverse = index % 2 === 1;

  return (
    <section
      data-testid={`menu-section-${section.id}`}
      className="relative scroll-mt-24"
      id={section.id}
    >
      <div className={`grid gap-8 md:gap-12 md:grid-cols-12 items-start ${reverse ? "" : ""}`}>
        {/* Image */}
        <div className={`md:col-span-5 ${reverse ? "md:order-2" : ""}`}>
          <div className="md:sticky md:top-28">
            <div className="relative overflow-hidden rounded-3xl aspect-[4/3] md:aspect-[4/5] glass-card p-1.5">
              <img
                src={section.image}
                alt={heading}
                loading="lazy"
                className="w-full h-full object-cover rounded-[1.3rem]"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
              <div className="absolute inset-1.5 rounded-[1.3rem] bg-gradient-to-t from-emerald-950/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-5 right-5">
                <span className="inline-block text-[10px] uppercase tracking-[0.3em] text-amber-200/90 mb-2">
                  {t.card_label}
                </span>
                <h3 className="font-serif text-3xl md:text-4xl text-white drop-shadow-lg leading-tight">
                  {heading}
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Items */}
        <div className={`md:col-span-7 ${reverse ? "md:order-1" : ""}`}>
          <div className="glass-card p-6 sm:p-8">
            <div className="flex items-baseline justify-between mb-5">
              <h2 className="font-serif text-2xl sm:text-3xl text-amber-100">{heading}</h2>
              <span className="text-[10px] uppercase tracking-[0.3em] text-amber-300/70">
                {String(index + 1).padStart(2, "0")}
              </span>
            </div>
            {section.note && (
              <p className="text-xs sm:text-sm italic text-white/65 mb-6 border-l-2 border-amber-300/40 pl-3">
                {tx(section.note)}
              </p>
            )}
            <ul className="divide-y divide-white/10">
              {section.items.map((item, i) => (
                <li
                  key={i}
                  data-testid={`menu-item-${section.id}-${i}`}
                  className="py-4 flex gap-4 items-start group"
                >
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-baseline gap-2 mb-1">
                      <h4 className="font-medium text-white tracking-wide group-hover:text-amber-100 transition">
                        {translateDish(item.name, lang)}
                      </h4>
                      <span className="hidden sm:block flex-1 border-b border-dotted border-white/15 mb-1 mx-1" />
                      <span
                        data-testid={`price-${section.id}-${i}`}
                        className="font-serif text-amber-200 text-base sm:text-lg whitespace-nowrap"
                      >
                        {item.price}
                      </span>
                    </div>
                    {item.desc && (
                      <p className="text-sm text-white/65 leading-relaxed pr-2">
                        {tx(item.desc)}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
